import { connect } from 'react-redux';
// import HSGHeader from '../HSGHeaderContainer/Component/HSGHeader';
import Actions from '../../Actions/Creators';
import Dashboard from './Component/Dashboard';
import Rightbar from './Component/Rightbar'
import Phi from '../../Phi/Phi'
import { withRouter } from 'react-router-dom';
import Leftbar from '../DashboardContainer/Component/Leftbar'



const mapStateToProps = (state, ownProps) => ({

    organizationId: JSON.parse(Phi.Storage.getItem('organization')) ? JSON.parse(Phi.Storage.getItem('organization'))[0].org_id : null,
    currentProgram: state.organization.currentProgram,    
    organization: state.organization.currentOrganization,
    programs: state.organization.programs,
    startNodeMap: state.organization.startNodeMap,
    htmlContent: state.organization.htmlContent,
    overViewReport: state.organization.overViewReport,
    history:state.organization.history,

    episodeStats: state.student.episodeStats,

    
 

    

});



const mapDispatchToProps = (dispatch) => ({
    getReport: (reportType, config) => dispatch(Actions.getReport(reportType, config)),
    getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
    fetchEpisodeStats: (inOrganizationId,inStatLimit,inClass,inSection) => dispatch(Actions.fetchClinicEpisodeStats(inOrganizationId,inStatLimit,inClass,inSection)),
    setLoader: () => dispatch(Actions.setLoader()),
    unsetLoader: () => dispatch(Actions.unsetLoader()),
    fetchOverViewReport: (startNode) => dispatch(Actions.fetchOverViewReport(startNode)),
    changeReportInReducer: (billingId) => dispatch(Actions.changeReportInReducer(billingId)),



});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard))




